import React, { useState } from 'react';
import { Container, Menu, Image, Dropdown } from 'semantic-ui-react';

const supervisorOptions = [
  { key: 's1', text: 'Supervisor 1', value: 'Supervisor 1' },
  { key: 's2', text: 'Supervisor 2', value: 'Supervisor 2' },
  { key: 's3', text: 'Supervisor 3', value: 'Supervisor 3' },
];

function NavBar() {
  const [supervisor, setSupervisor] = useState('Supervisor 1');

  return (
    <Menu>
      <Container text>
        <Menu.Item>
          <i className='phone icon'></i>
        </Menu.Item>

        <Menu.Item header>Call Center</Menu.Item>

        <Menu.Item position='right'>
          <Image
            src='https://react.semantic-ui.com/images/avatar/large/chris.jpg'
            avatar
          />
        </Menu.Item>

        <Menu.Item>
          <Dropdown
            inline
            options={supervisorOptions}
            value={supervisor}
            onChange={(e, { value }) => {
              setSupervisor(value);
              // TODO: later, call your script here with `value`
            }}
          />
        </Menu.Item>
      </Container>
    </Menu>
  );
}

export default NavBar;



/*import React from 'react';
import { Container, Menu, Image } from 'semantic-ui-react';

function NavBar() {
  return (
    <Menu>
      <Container text>
        <Menu.Item>
          <i className='phone icon'></i>
        </Menu.Item>
        <Menu.Item header>Call Center</Menu.Item>
        <Menu.Item position='right'>
          <Image
            src='https://react.semantic-ui.com/images/avatar/large/chris.jpg'
            avatar
          />
        </Menu.Item>
        <Menu.Item>Chris</Menu.Item>
      </Container>
    </Menu>
  );
}

export default NavBar;
*/